export default "__VITE_ASSET__CZ4M9yYm__"